import Navbar from "../components/Navbar";
import ImageCard from "../components/ImageCard";
import ImageCardDetails from "../components/ImageCardDetails";
import ContactSection from "../components/ContactSection";
import FaqSection from "../components/FaqSection";
import Sidebar from "../components/Sidebar";
// import integrationHeroImage from "./../assets/integration-hero-image.png";
import customDashboardImage from "./../assets/custom-dashboard-image.png";
import productInnovationImage from "./../assets/product-innovation-image.png";
import threadhausProductImage from "./../assets/threadhaus-product-image.png";
import customGptImage from "./../assets/custom-gpt-image.png";
import evenessAlgoImage from "./../assets/eveness-algo-image.png";
import { homeDesktopItems, homeMobileItems } from "../data/mockData";
import Footer from "../components/Footer";
import { Link } from "react-router-dom";
import { demoFaqs } from "../data/faqs";

const Demo = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar desktopItems={homeDesktopItems} mobileItems={homeMobileItems} />
      <main className="pl-0 md:pl-6">
        {/* Page layout: sidebar + content */}
        <div className="flex gap-1">
          {/* Sidebar */}
          <Sidebar />

          {/* Content */}
          <div className="flex-1">
            {/* HERO SECTION */}
            <section className="rounded-[10px] bg-white p-6">
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
                <div className="order-1 lg:order-2 lg:justify-self-end w-full">
                  <div className="w-full h-[396px] rounded-[10px] overflow-hidden relative bg-[linear-gradient(to_bottom,_#E9D6D2_0%,_#DFA8A1_45%,_#C97F7C_75%,_#B75E5C_100%)]">
                    <div className="absolute inset-0 flex items-center justify-center">
                      <div className="h-[65%] rounded-[8px] overflow-hidden">
                        {/* <img
                          src={integrationHeroImage}
                          alt="Eveness solutions hero"
                          className="w-full h-full object-contain"
                          loading="lazy"
                        /> */}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="order-2 lg:order-1 max-w-[520px]">
                  <div className="text-[32px] md:text-[38px] leading-[100%] font-normal tracking-[-1.6px] text-black font-inter">
                    Thread Haus Integration
                  </div>

                  <p className="mt-4 text-[14.5px] leading-[23.4px] tracking-[0.17px] align-middle text-[#1A1A1A] max-w-[440px] font-normal">
                    Take a look at Eveness' partner brand, ThreadHaus, to see
                    our integration in live action.{" "}
                  </p>

                  <Link to="/get-started">
                    <button
                      type="button"
                      className="mt-6 inline-flex items-center justify-center w-[124px] h-[40px] rounded-[8px] px-[20px] py-[12.6px] border border-black bg-white text-black opacity-100 whitespace-nowrap transition-colors duration-200 hover:bg-black hover:text-white"
                    >
                      Get Started
                    </button>
                  </Link>
                </div>
              </div>{" "}
            </section>
            {/* SECOND SECTION */}
            <section className="mt-[40px] md:mt-[100px] rounded-[10px] bg-white p-6 mb-[50px]">
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-stretch bg-white">
                <ImageCard
                  imageSrc={threadhausProductImage}
                  bgColor={"#E9F3FF"}
                  source="demo"
                />
                <ImageCardDetails
                  title="Thread Haus Product Description Page"
                  description="Learn the best colors, silhouettes, and necklines based on your Color Analysis, Face, and Body Shape."
                  linkTextOne="Product description page with fit and size check agent"
                  linkTextTwo="Product description page with fit and size check agent"
                />
              </div>

              <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-stretch mt-[50px] bg-white">
                <div className="order-2 lg:order-1">
                  <ImageCardDetails
                    title="Custom Eveness GPT"
                    description="Your Brand Chatbot powered with your product catalogue."
                    linkTextOne="Product description page with fit and size check agent"
                    linkTextTwo="Product description page with fit and size check agent"
                  />
                </div>
                <div className="order-1 lg:order-2">
                  <ImageCard imageSrc={customGptImage} bgColor={"#DAF3DA4D"} source="demo" />
                </div>
              </div>
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-stretch mt-[50px]">
                <ImageCard imageSrc={evenessAlgoImage} bgColor={"#F7F2F2"} />
                <ImageCardDetails
                  title="The Eveness Algorithm"
                  description="A Recommender Algorithm Trained of Styling Research, that looks at the user's features and the garment to help match the most flattering garments."
                  linkTextOne="Product description page with fit and size check agent"
                  linkTextTwo="Product description page with fit and size check agent"
                />
              </div>

              <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-stretch mt-[50px] bg-white">
                <div className="order-2 lg:order-1">
                  <ImageCardDetails
                    title="Custom Dashboard"
                    description="Learn the best colors, silhouettes, and necklines based on your Color Analysis, Face, and Body Shape."
                    linkTextOne="Product description page with fit and size check agent"
                    linkTextTwo="Product description page with fit and size check agent"
                  />
                </div>
                <div className="order-1 lg:order-2">
                  <ImageCard
                    imageSrc={customDashboardImage}
                    bgColor={"#F7F2F7"}
                  />
                </div>
              </div>
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-stretch mt-[50px]">
                <ImageCard
                  imageSrc={productInnovationImage}
                  bgColor={"#F2F6F7"}
                />
                <ImageCardDetails
                  title="Limit Returns and Data-Drive Product Innovation"
                  description="The Eveness Algorithm expanded to more than the collection. Shop from a variety of brands with our help pieces that highlight you."
                  linkTextOne="Product description page with fit and size check agent"
                  linkTextTwo="Product description page with fit and size check agent"
                />
              </div>
            </section>

            <section className="mt-10 rounded-[10px] px-3 md:px-6">
              <ContactSection />
              <div className="mt-[52px]">
                <FaqSection faqs={demoFaqs} />
              </div>
            </section>
            <Footer />
          </div>
        </div>
      </main>
    </div>
  );
};

export default Demo;
